<script setup lang="ts">
import Redirect from './Redirect.vue';

import { useAgentLoggedQuery } from '@/graphql/generated/graphql';
import StartLogo from '@/ui/StartLogo.vue';
import useRights from '@/providers/useRights';
import { verifyRoute, verifyRouteResponse } from '@/router/verifyRoute';
import type routeTypeEnum from '~/router/routeTypeEnum';
import Forbidden from '~/templates/Error/Forbidden.vue';

const { data, fetching } = useAgentLoggedQuery({});

const { setRight } = useRights();
const route = useRoute();
const routeRight = computed(() => verifyRoute(
  route.meta.rights as string[],
  route.meta.layout as routeTypeEnum,
  data.value?.agentLogged,
));
setRight(routeRight.value);
const redirect = computed(() => window.location.href);
</script>

<template>
  <StartLogo v-if="fetching" text="Loading agent..." :percent="90" />
  <template v-else-if="data?.agentLogged">
    <div v-if="routeRight === verifyRouteResponse.forbidden">
      <Forbidden />
    </div>
    <slot v-else />
  </template>
  <Redirect v-else :redirect-url="redirect" />
</template>
